import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    phoneCode: null,
    topUrl: null,
    passport: null,
    userInfo: null, // 用户信息
    cards: null, // 可用的vip卡
    tickets: null, // 可用的优惠券
    afterLoginPath: null, // 登录后的重定向路径
  },
  getters: {},
  mutations: {
    // 储存区号
    SET_PHONE_CODE: (state, code) => {
      state.phoneCode = code
    },
    // 储存区号
    SET_TOP_URL: (state, urlObj) => {
      state.topUrl = urlObj
    },
    // 储存passport
    SET_PASSPORT: (state, passport) => {
      state.passport = passport
    },
    // 储存用户信息
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    //
    SAVE_CARDS: (state, data) => {
      state.cards = data
    },
    SAVE_TICKETS: (state, data) => {
      state.tickets = data
    },
    // 清理缓存
    CLEAR_ALL: (state) => {
      state.passport = null
      state.userInfo = null
      state.cards = null
      state.tickets = null
    },
    SET_AFTER_LOGIN_PATH: (state, path) => {
      // 设置登录后的重定向路径
      state.afterLoginPath = path
    },
  },
  actions: {
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: ['phoneCode', 'passport','userInfo','topUrl'], // 配置持久化储存的内容
    }),
  ],
})
